import React, {useContext,useState,useEffect} from 'react';
import {MyContext} from '../../login/MyContext';
//import {Link} from 'react-router-dom';
import Login from '../../login/Login';
import axios from 'axios';

import Count from '../principal/Count';

function Anuncios () {
 
    const {user} = useContext(MyContext); 
    
   

    const [web, setData]=useState([]);
    

    const peticionGet =async() =>{
      await axios.get(`https://manager-ads.com/ApiAliraweb.com/anuncios/anuncios.php?id=${global.id}`)
      .then(res=>{
       setData(res.data);
      
      }).catch(error=>{
        console.log(error);
      })
  
    }

    useEffect(()=>{
    

        const interval = setInterval(() => {
          
         peticionGet();
         
           
         }, 1000);
      
       return () => setInterval(interval);
      
       },[])

  
    
    if(user)
    {
  return (
 
<div id="content" class="app-content">

<ol class="breadcrumb float-xl-end">


</ol>





<Count/>



<div class="row">

<div class="col-xl-12">


<div class="panel panel-inverse" data-sortable-id="form-stuff-1" data-init="true">

<div class="panel-heading ui-sortable-handle">

<h4 class="panel-title">ANUNCIOS</h4>
<div class="panel-heading-btn">
<a href="javascript:;" class="btn btn-xs btn-icon btn-default" data-toggle="panel-expand" title="Expandir"><i class="fa fa-expand"></i></a>

</div>
</div>


<div class="panel-body ">
{/*div class="alert alert-muted">
Textual form controls—like <code>&lt;input&gt;</code>s, <code>&lt;textarea&gt;</code>s, <code>&lt;select&gt;</code>s are styled with the <code>.form-control</code> and <code>.form-select</code> class. Included are styles for general appearance, focus state, sizing, and more.
</div> */}
<form>
 

<div class=" row mb-15px ">

<label class="form-label col-form-label col-md-2 "></label>

<img src="../assets/img/logo/google2.svg" style={{width:'800px'}} />

<div class="col-sm-7 ">



</div>

</div>



<div class="row mb-15px">


<label class="form-label col-form-label col-md-2">Todos Mis Anuncios:</label>
<div class="col-md-7">
<input type="text" readOnly style={{textAlign:'center',  fontSize:'15px'}} class="form-control mb-5px " placeholder="Anuncio"
value={web}   />
<br/>

</div>



<div class="col-md-2">

<div class="alert alert-green alert-dismissible fade show mb-0" style={{padding: '0.6375rem 0.6375rem', textAlign:'center'}}>
<a><b>ANUNCIO ACTIVO</b> <i class="fas fa-check-circle fa-1x fa-lg" ></i></a>


</div>

</div>



</div>




</form>
</div>





</div>

</div>




</div>


</div>
   
  )
}

else if(!user){
    return"";
}

}

export default Anuncios
